import * as React from 'react';

import { ControlLinkButton } from '../../ControlLinkButton';
import { Filters } from '../../Icons';

import * as styles from './styles.css';

interface IFiltersButtonProps {
  url: string;
  onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void;
}

export function FiltersButton({ url, onClick }: IFiltersButtonProps) {
  return (
    <ControlLinkButton title="Фильтры" href={url} className={styles['navigation-btn']} onClick={onClick}>
      <Filters />
    </ControlLinkButton>
  );
}
